import { useDisclosure } from '@ds';
import { AviaLegTypes, GroundLegTypes, RouteLegTypeEnum } from '@/api/apis/route';
import { isAviaLegType, isGroundTripLegType, REPOSITION_SEGMENT_TYPES } from '@/utils/route';
import { LegInformationHeader } from './LegInformationHeader';
import { LegDateTime } from './LegDateTime';
import { LegDetailsResources } from './LegDetailsResources';
import { TransportInformation } from './TransportInformation';
import { TransportResources } from './TransportResources';
import { CaseGroundTripInfo } from './CaseGroundTripInfo';
import { GroundTripTitle } from './GroundTripTitle';
import { AviaTransportInfo } from './AviaTransportInfo';

type LegDetailsProps = {
  leg: AviaLegTypes | GroundLegTypes;
};

export const LegDetails = ({ leg }: LegDetailsProps) => {
  const { isOpen, onOpenChange } = useDisclosure();

  const isCurriService = leg.legType === RouteLegTypeEnum.CurriServiceGroundLeg;
  const isReposition = REPOSITION_SEGMENT_TYPES.includes(leg.segmentType);
  const isGroundTripLeg = isGroundTripLegType(leg);
  const isAviaLeg = isAviaLegType(leg);

  return (
    <div className="flex grow flex-col w-36 bg-base-80 p-4 rounded-md mb-2.5 gap-3">
      <LegInformationHeader isOpen={isOpen} leg={leg} onOpenChange={onOpenChange} />
      <LegDateTime leg={leg} />
      {!isOpen && isAviaLeg && <AviaTransportInfo leg={leg} />}
      {!isOpen && !isReposition && (
        <>
          {isGroundTripLeg && !!leg.tripReference?.tripId && <GroundTripTitle tripId={leg.tripReference.tripId} />}
          <LegDetailsResources type="compact" leg={leg} />
        </>
      )}
      {isOpen && (
        <div className="w-full flex flex-col items-stretch gap-4">
          <TransportInformation leg={leg} />
          <TransportResources leg={leg} />
          {!isReposition && <LegDetailsResources leg={leg} />}
          {isGroundTripLeg && !!leg.tripReference?.tripId && <CaseGroundTripInfo tripId={leg.tripReference.tripId} />}
          {isCurriService && !!leg.trackingNumber && (
            <div className="w-full p-2 rounded-lg bg-base-60 max-h-24 overflow-auto flex flex-col gap-1">
              <span className="text-s-sb">Tracking Link:</span>
              <span className="text-m-r text-base-5">{leg.trackingNumber}</span>
            </div>
          )}
          {!!leg.comments && (
            <div className="w-full p-2 rounded-lg bg-base-60 max-h-24 overflow-auto flex flex-col gap-1">
              <span className="text-s-sb">Comments:</span>
              <span className="text-m-r text-base-5">{leg.comments}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
